import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopViewComponent } from './top-view/top-view.component';
import { JumbotronComponent } from './jumbotron/jumbotron.component';
import { IsabelleComponent } from './isabelle/isabelle.component';
import { NavbarComponent } from './navbar/navbar.component';
import { CardsComponent } from './cards/cards.component';


@NgModule({
  imports: [
    CommonModule
  ],
  exports: [TopViewComponent, JumbotronComponent, IsabelleComponent, NavbarComponent, CardsComponent],
  declarations: [TopViewComponent, JumbotronComponent, IsabelleComponent, NavbarComponent, CardsComponent]
})
export class TopModule { }



// WEBPACK FOOTER //
// P:/Portfolio-angular-master/src/app/top/top.module.ts